/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/es'

import iconSet from 'quasar/icon-set/eva-icons'


import Vue from 'vue'

import {Quasar,Cookies,Notify,Loading,AddressbarColor,LocalStorage} from 'quasar'


Vue.use(Quasar, { config: {"loading":{"spinnerColor":"primary","backgroundColor":"white"}},lang: lang,iconSet: iconSet,plugins: {Cookies,Notify,Loading,AddressbarColor,LocalStorage} })
